// extracted by mini-css-extract-plugin
export default {"block":"BlockFIle_block__7WeBw","text":"BlockFIle_text__yzVSt","icon":"BlockFIle_icon__hc+N9"};